/** SentimentTypeID: 1 = Bullish, 3 = Bearish. */
export const SENTIMENT_TYPE_BULLISH = 1;
export const SENTIMENT_TYPE_BEARISH = 3;

export const SENTIMENT_OPTIONS = [
  { value: SENTIMENT_TYPE_BULLISH, label: "Bullish", color: "text-green-600" },
  { value: SENTIMENT_TYPE_BEARISH, label: "Bearish", color: "text-red-600" },
] as const;

/**
 * Unified factor row. Stocks live in TopBullBearKeyPointTranslation
 * (id = bullBearKeyPointId), ETFs in EtfPositiveNegativeTranslation
 * (id = etfPositiveNegativeId). Both normalize to `factorId`.
 */
export interface FactorRow {
  factorId: number;
  stockId: number;
  sentimentTypeId: number;
  topic: string | null;
  keyPoint: string | null;
  languageId: number;
  addedOn: Date | string;
}

export interface AssetTranslationAggregate {
  stockId: number;
  ticker: string | null;
  /** True if the asset is an ETF (factors come from EtfPositiveNegativeTranslation). */
  isEtf: boolean;
  companyName: string;
  description: string;
  incomeSources: string;
  bullishSummary: string;
  bearishSummary: string;
  factors: FactorRow[];
}

export interface TranslationListItem {
  stockId: number;
  ticker: string | null;
  companyName: string;
  keypointCount: number;
}

export interface TranslationsListResponse {
  translations: TranslationListItem[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export function createEmptyFactor(stockId: number): FactorRow {
  return {
    factorId: 0,
    stockId,
    sentimentTypeId: SENTIMENT_TYPE_BULLISH,
    keyPoint: "",
    topic: null,
    languageId: 3,
    addedOn: new Date().toISOString(),
  };
}

export function createEmptyAggregate(): AssetTranslationAggregate {
  return {
    stockId: 0,
    ticker: null,
    isEtf: false,
    companyName: "",
    description: "",
    incomeSources: "",
    bullishSummary: "",
    bearishSummary: "",
    factors: [],
  };
}

export function sentimentLabel(sentimentTypeId: number): string {
  return sentimentTypeId === SENTIMENT_TYPE_BULLISH ? "Bullish" : "Bearish";
}
